function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.025 18.128c.683-1.17.975-3.06.975-6.13 0-3.06-.29-4.938-.98-6.14-.692-1.249-1.513-1.645-3.142-1.74C17.766 4.043 15.002 4 12.003 4c-3.006 0-5.772.043-6.892.118-1.62.095-2.44.492-3.14 1.745C1.292 7.06 1 8.947 1 12.008c0 3.044.293 4.94.978 6.134.689 1.236 1.497 1.629 3.13 1.744 1.175.068 4.096.114 6.895.114 2.792 0 5.712-.046 6.875-.114 1.649-.115 2.457-.508 3.147-1.758zM18.752 6.114c1.02.06 1.208.151 1.531.736.47.814.717 2.408.717 5.158 0 2.73-.248 4.333-.715 5.133-.324.586-.511.678-1.535.75-1.101.064-3.993.109-6.747.109-2.76 0-5.654-.045-6.766-.11-1.011-.071-1.201-.164-1.518-.732-.47-.82-.719-2.431-.719-5.16s.248-4.332.715-5.155c.322-.577.513-.67 1.522-.729C6.305 6.042 9.044 6 12.003 6c2.952 0 5.69.042 6.75.114zM10 9l5 3-5 3V9z",
  fill: "#000"
});

function SvgYoutube(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgYoutube;